import React from "react";
import { useAppSettings } from "../../hooks/useAppSettings.tsx";
import Layout from "../../components/Layout.tsx";
import QrScanner from "./QrScanner.tsx";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/index.ts";
import { useNavigate } from "react-router-dom";
import { logout } from "../../store/slices/authSlice.ts";

type Props = {};

const RelojChecador = (props: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state: RootState) => state.auth);
  useAppSettings();

  if (user?.rol !== "Reloj checador") {
    dispatch(logout());
    navigate("/");
  }

  return (
    <Layout>
      <QrScanner />
    </Layout>
  );
};

export default RelojChecador;